var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "apps-wrapper" },
    [
      _c("AppBreadCrumb", {
        attrs: { paths: [{ title: _vm.$t("message.getApps") }] },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "apps-main" },
        [
          _c("div", { staticClass: "left" }, [
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n                    Supsis Mobil App Yeni Sürüm Yayında 🚀\n                "
                ),
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "buttons" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "email-button" }, [
                  _c(
                    "div",
                    {
                      staticClass: "send-mail",
                      on: {
                        click: function ($event) {
                          _vm.showModal = true
                        },
                      },
                    },
                    [_vm._v("Email Gönder")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "bubble2" }),
            _vm._v(" "),
            _c("div", { staticClass: "bubble3" }),
          ]),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm.showModal
            ? _c(
                "Modal",
                {
                  staticClass: "email-modal",
                  attrs: {
                    "show-footer": false,
                    title: "Uygulama Linki Gönderimi",
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.showModal = false
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "mr-auto" },
                    [
                      _c("div", [
                        _c("h4", { staticClass: "font-color" }, [
                          _vm._v(_vm._s(_vm.$t("message.weLlSendEmail"))),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "font-color" }, [
                          _vm._v(_vm._s(_vm.$t("message.offerlinkSendToMail"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "md-radio",
                            {
                              attrs: { value: "accent" },
                              on: { change: _vm.radioControl },
                              model: {
                                value: _vm.radio,
                                callback: function ($$v) {
                                  _vm.radio = $$v
                                },
                                expression: "radio",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("message.theEmail")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-radio",
                            {
                              staticClass: "md-primary",
                              attrs: { value: "Primary" },
                              model: {
                                value: _vm.radio,
                                callback: function ($$v) {
                                  _vm.radio = $$v
                                },
                                expression: "radio",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("message.differentEmail")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.email"))),
                          ]),
                          _vm._v(" "),
                          _c("md-input", {
                            staticClass: "font-color",
                            attrs: {
                              label: _vm.$t("message.email"),
                              autocomplete: "off",
                              trim: "",
                              type: "tel",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.isEmailValid()
                              },
                            },
                            model: {
                              value: _vm.email,
                              callback: function ($$v) {
                                _vm.email = $$v
                              },
                              expression: "email",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass:
                            "font-color md-dense md-raised md-primary m-0",
                          attrs: {
                            disabled: this.validMail === "classs-error",
                          },
                          on: { click: _vm.send },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.isEmailValid()) +
                              _vm._s(_vm.$t("message.send")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          "İşletmenizi nerede olursanız olun yönetin! SUPSIS’in güçlü özellikleri şimdi App Store ve\n                        Google\n                        Play’de.\n                    "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-buttons" }, [
      _c(
        "a",
        {
          staticClass: "app-store",
          attrs: {
            href: "https://apps.apple.com/tr/app/supsis-live/id6474663686",
            target: "_blank",
          },
        },
        [
          _c("img", {
            attrs: {
              src: "https://static.supsis.live/common/image/AppStore.png",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "google-play",
          attrs: {
            href: "https://play.google.com/store/apps/details?id=com.softcand.supsis&hl=en_ZA&gl=US&pli=1",
            target: "_blank",
          },
        },
        [
          _c("img", {
            attrs: {
              src: "https://static.supsis.live/common/image/GooglePlay.png",
            },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bubble1" }, [
      _c("div", { staticClass: "vignette" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "gallery" }, [
        _c("div", { staticClass: "descriptions" }, [
          _c("div", { staticClass: "description" }, [
            _c("p", [_vm._v("Chatbot Sayesinde")]),
            _vm._v(" "),
            _c("p", [_c("b", [_vm._v("7/24 Desteği Sürdürün")])]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _c("p", [_vm._v("Anlık Mesajlar")]),
            _vm._v(" "),
            _c("p", [_c("b", [_vm._v("Gönderin ve Alın")])]),
            _vm._v(" "),
            _c("p", { staticStyle: { "font-size": "15px" } }, [
              _vm._v("Ses, Dosya ve Konum Bilgisi Paylaşın"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _c("p", [_vm._v("Sesli ve Görüntülü")]),
            _vm._v(" "),
            _c("p", [_vm._v("Görüşme Özelliği ile")]),
            _vm._v(" "),
            _c("p", [_c("b", [_vm._v("Sorunları Hızla Çözün")])]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "images" }, [
          _c("div", { staticClass: "image" }, [
            _c("img", {
              attrs: {
                src: "https://static.supsis.live/common/image/Supsis_app_Chatbot.png",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "image little" }, [
            _c("img", {
              attrs: {
                src: "https://static.supsis.live/common/image/Supsis_app_Location.png",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "image" }, [
            _c("img", {
              attrs: {
                src: "https://static.supsis.live/common/image/Supsis_app_VideoCall.png",
              },
            }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }